<div class="modal-header" id="report-issue-modal-title">
    <h3 class="modal-title" id="modal-title" translate="REPORT_ISSUE_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="reportIssueForm">
        <div *ngIf="isNgmP58" class="row mb-3">
            <strong class="p-2">
                Dear user, please ensure to describe your incident always in English and with the needed level of
                detail. Only this way we are able to help you within the agreed timeframe.</strong
            >
        </div>

        <div class="row mb-3">
            <label
                for="gid"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="REPORT_ISSUE_FIELD_GID"
            ></label>
            <div class="col-sm-9">
                <pace-core-text-input
                    [(model)]="model.gid"
                    id="gid"
                    [parentForm]="formChildren"
                    [ariaLabel]="'REPORT_ISSUE_FIELD_GID' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                for="description"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="REPORT_ISSUE_FIELD_DESCRIPTION"
            ></label>
            <div class="col-sm-9">
                <pace-core-text-input
                    [(model)]="model.issue_description"
                    id="description"
                    [parentForm]="formChildren"
                    [ariaLabel]="'REPORT_ISSUE_FIELD_DESCRIPTION' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                for="notification_num"
                class="col-sm-3 text-sm-end text-start col-form-label text-nowrap"
                translate="REPORT_ISSUE_FIELD_NOTIFICATION_NUMBER"
            ></label>
            <div class="col-sm-4 pe-0 ps-2">
                <pace-core-text-input
                    [(model)]="model.notification_num"
                    id="notification_num"
                    [parentForm]="formChildren"
                    [ariaLabel]="'REPORT_ISSUE_FIELD_NOTIFICATION_NUMBER' | translate"
                ></pace-core-text-input>
            </div>

            <div class="w-100 d-sm-none mb-3"></div>

            <label
                for="material_num"
                class="col-sm-2 text-sm-end text-start col-form-label text-nowrap"
                translate="REPORT_ISSUE_FIELD_MATERIAL_NUMBER"
            ></label>
            <div class="col-sm-3">
                <pace-core-text-input
                    [(model)]="model.material_num"
                    id="material_num"
                    [parentForm]="formChildren"
                    [ariaLabel]="'REPORT_ISSUE_FIELD_MATERIAL_NUMBER' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                for="date_time"
                class="col-sm-3 text-sm-end text-start col-form-label text-nowrap"
                translate="REPORT_ISSUE_FIELD_DATE_TIME"
            ></label>
            <div class="col-sm-4 pe-0 ps-2">
                <pace-core-datetime-input
                    [(model)]="model.date_time"
                    id="date_time"
                    [parentForm]="formChildren"
                    [ariaLabel]="'REPORT_ISSUE_FIELD_DATE_TIME' | translate"
                ></pace-core-datetime-input>
            </div>

            <div class="w-100 d-sm-none mb-3"></div>

            <label
                for="form_id"
                class="col-sm-2 text-sm-end text-start col-form-label text-nowrap"
                translate="REPORT_ISSUE_FIELD_FORM_ID"
            ></label>
            <div class="col-sm-3">
                <pace-core-text-input
                    [(model)]="model.form_id"
                    id="form_id"
                    [parentForm]="formChildren"
                    [ariaLabel]="'REPORT_ISSUE_FIELD_FORM_ID' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                for="actual_behavior"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="REPORT_ISSUE_FIELD_ACTUAL_BEHAVIOR"
            ></label>
            <div class="col-sm-9">
                <pace-core-text-input
                    [(model)]="model.actual_behaviour"
                    id="actual_behavior"
                    [parentForm]="formChildren"
                    [ariaLabel]="'REPORT_ISSUE_FIELD_ACTUAL_BEHAVIOR' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                for="expected_behavior"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="REPORT_ISSUE_FIELD_EXPECTED_BEHAVIOR"
            ></label>
            <div class="col-sm-9">
                <pace-core-text-input
                    [(model)]="model.expected_behaviour"
                    id="expected_behavior"
                    [parentForm]="formChildren"
                    [ariaLabel]="'REPORT_ISSUE_FIELD_EXPECTED_BEHAVIOR' | translate"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                for="steps_to_reproduce"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="REPORT_ISSUE_FIELD_STEPS_TO_REPRODUCE"
            ></label>
            <div class="col-sm-9">
                <pace-core-text-input
                    [(model)]="model.steps_to_reproduce"
                    id="steps_to_reproduce"
                    [parentForm]="formChildren"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                for="personal_urgency"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="REPORT_ISSUE_FIELD_PERSONAL_URGENCY"
            ></label>
            <div class="col-sm-9">
                <pace-core-dropdown
                    [(model)]="model.personal_urgency"
                    id="personal_urgency"
                    [parentForm]="formChildren"
                ></pace-core-dropdown>
            </div>
        </div>
        <div class="row mb-3">
            <label
                for="category"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="REPORT_ISSUE_FIELD_CATEGORY"
            ></label>
            <div class="col-sm-9">
                <pace-core-radio-input
                    [(model)]="model.category"
                    id="category"
                    [parentForm]="formChildren"
                ></pace-core-radio-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                for="files"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="REPORT_ISSUE_FIELD_UPLOAD_DOCUMENTS"
            ></label>
            <div class="col-sm-9">
                <pace-core-file-upload
                    name="files"
                    [allowedMimeTypes]="allowedMimeTypes"
                    (filesChange)="onFileSelected($event)"
                ></pace-core-file-upload>
            </div>
        </div>
        <div class="row mb-3" *ngIf="model?.files?.length > 0">
            <label class="col-sm-3"></label>
            <div class="col-sm-9 d-flex align-items-center">
                <pace-core-checkbox-input
                    class="me-2 text-nowrap"
                    [(model)]="model.phiAgreement"
                    [parentForm]="formChildren"
                ></pace-core-checkbox-input>

                <label class="mb-0 d-flex align-items-center" for="phi_agreement">
                    {{ 'REPORT_ISSUE_FORM_DOCUMENT_PHI_AGREEMENT' | translate }}
                    <a
                        href="https://intranet.apps.siemens-healthineers.com/Med_TD/CS_Guidelines/guidelines/r2/ARTD/1e72201.pdf"
                        target="_blank"
                        class="ms-2"
                        (click)="$event.stopPropagation()"
                    >
                        {{ 'REPORT_ISSUE_FORM_LINK_PHI' | translate }}
                    </a>
                </label>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button
        class="btn btn-secondary"
        type="button"
        (click)="modalInstance.hide()"
        translate="REPORT_ISSUE_CANCEL_BUTTON_TEXT"
    ></button>
    <button
        class="btn btn-primary"
        type="button"
        (click)="submitData()"
        [disabled]="reportIssueForm.invalid"
        translate="REPORT_ISSUE_SUBMIT_BUTTON_TEXT"
    ></button>
</div>
